module.exports = __webpack_public_path__ + "media/87.febde7d9.mp3";